// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AssetPreviewController from "./asset_preview_controller";
application.register("asset-preview", AssetPreviewController);

import AudioMetadataController from "./audio_metadata_controller";
application.register("audio-metadata", AudioMetadataController);

import AudioPlayerController from "./audio_player_controller";
application.register("audio-player", AudioPlayerController);

import BgmLibraryController from "./bgm_library_controller";
application.register("bgm-library", BgmLibraryController);

import BgmSelectController from "./bgm_select_controller";
application.register("bgm-select", BgmSelectController);

import BgmWizardController from "./bgm_wizard_controller";
application.register("bgm-wizard", BgmWizardController);

import BgmPickerModalController from "./bgm_picker_modal_controller";
application.register("bgm-picker-modal", BgmPickerModalController);

import BrandFormController from "./brand_form_controller";
application.register("brand-form", BrandFormController);

import BrandPickerController from "./brand_picker_controller";
application.register("brand-picker", BrandPickerController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import LocaleSwitcherController from "./locale_switcher_controller";
application.register("locale-switcher", LocaleSwitcherController);

import ConfirmDialogController from "./confirm_dialog_controller";
application.register("confirm-dialog", ConfirmDialogController);

import FormSubmitController from "./form_submit_controller";
application.register("form-submit", FormSubmitController);

import PreviewModalController from "./preview_modal_controller";
application.register("preview-modal", PreviewModalController);

import ProjectStatusController from "./project_status_controller";
application.register("project-status", ProjectStatusController);

import ProjectWizardController from "./project_wizard_controller";
application.register("project-wizard", ProjectWizardController);

import RegenerateModalController from "./regenerate_modal_controller";
application.register("regenerate-modal", RegenerateModalController);

import RenderProgressController from "./render_progress_controller";
application.register("render-progress", RenderProgressController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);

import UploadPreviewController from "./upload_preview_controller";
application.register("upload-preview", UploadPreviewController);

import VideojsController from "./videojs_controller";
application.register("videojs", VideojsController);

import PropertyDetailsController from "./property_details_controller";
application.register("property-details", PropertyDetailsController);

import TelemetryDashboardController from "./telemetry_dashboard_controller";
application.register("telemetry-dashboard", TelemetryDashboardController);

import TelemetryStreamController from "./telemetry_stream_controller";
application.register("telemetry-stream", TelemetryStreamController);

import PromptModalController from "./prompt_modal_controller";
application.register("prompt-modal", PromptModalController);

import TelemetryTabsController from "./telemetry_tabs_controller";
application.register("telemetry-tabs", TelemetryTabsController);

import TelemetryAuditController from "./telemetry_audit_controller";
application.register("telemetry-audit", TelemetryAuditController);

import WorkspaceFilesController from "./workspace_files_controller";
application.register("workspace-files", WorkspaceFilesController);

import FilterBarController from "./filter_bar_controller";
application.register("filter-bar", FilterBarController);

import ConnectivityController from "./connectivity_controller";
application.register("connectivity", ConnectivityController);

import NowPlayingController from "./now_playing_controller";
application.register("now-playing", NowPlayingController);

import WhatsNewController from "./whats_new_controller";
application.register("whats-new", WhatsNewController);

import InfoPopoverController from "./info_popover_controller";
application.register("info-popover", InfoPopoverController);

import SearchFormController from "./search_form_controller";
application.register("search-form", SearchFormController);

import SettingsPopoverController from "./settings_popover_controller";
application.register("settings-popover", SettingsPopoverController);

import AuthTabsController from "./auth_tabs_controller";
application.register("auth-tabs", AuthTabsController);

import LandingNavController from "./landing_nav_controller";
application.register("landing-nav", LandingNavController);

import LazyVideoController from "./lazy_video_controller";
application.register("lazy-video", LazyVideoController);
